import {
  buildPaymentSummaryQuery,
  hasRequiredFilterKeys,
  paymentSummaryCardsFromResponse,
} from "@/components/receipt-payment-summary/payment-summary-factory";
import type {
  PaymentSummaryCardView,
  PaymentSummaryResponse,
} from "@/components/receipt-payment-summary/types";

export const RENT_SUMMARY_QUERY_KEYS = ["start", "end", "type", "mode", "q", "receiptNo"] as const;

export type RentSummaryQueryKey = (typeof RENT_SUMMARY_QUERY_KEYS)[number];

export const RENT_PAYMENT_SUMMARY_PATH = "contRcpt/summary/payment-mode";

/** Rent uses `start`/`end` (not startDate/endDate). */
export const RENT_SUMMARY_REQUIRED_DATE_KEYS = ["start", "end"] as const;

export function buildRentSummaryQuery(filterValues: Record<string, unknown>): URLSearchParams {
  return buildPaymentSummaryQuery(filterValues, RENT_SUMMARY_QUERY_KEYS);
}

export function shouldFetchRentPaymentSummary(filterValues: Record<string, unknown>): boolean {
  return hasRequiredFilterKeys(filterValues, RENT_SUMMARY_REQUIRED_DATE_KEYS);
}

export function rentPaymentSummaryCardsFromResponse(
  summary: PaymentSummaryResponse
): PaymentSummaryCardView[] {
  return paymentSummaryCardsFromResponse(summary);
}
